<script>
  import LoanOptions from "./LoanOptions.svelte";
  import ValidationError from "../Misc/ValidationError.svelte";
  let showOptions = false;
  let loanAmount = 8000,
    creditScore = 720,
    borrowerCount = 1,
    state = "",
    closingDate;
  let loanAmountValidationError,
    creditScoreValidationError,
    borrowerCountValidationError,
    stateValidationError;

  function showRates() {
    let isValid = true;
    if (!loanAmount || loanAmount < 2000 || loanAmount > 20000) {
      loanAmountValidationError =
        "Loan amount must be between $2000 - $20,000. For loans greater that $20,000 please contact us directly at Josh@closingcosthelp.com";
      isValid = false;
    }

    if (!creditScore || creditScore < 619) {
      creditScoreValidationError = "Credit score must be greater than 619.";
      isValid = false;
    }

    if (!creditScore || creditScore > 850) {
      creditScoreValidationError = "Please provide a valid credit score";
      isValid = false;
    }

    if (!borrowerCount || borrowerCount < 1) {
      borrowerCountValidationError = "You must have at least one borrower";
      isValid = false;
    }

    if (!state || !state.length || state === "--") {
      stateValidationError = "Please select a State";
      isValid = false;
    }

    if(state === 'New Mexico - NM' && loanAmount <= 5000) {
      loanAmountValidationError = "Loan amounts for New Mexico must be greater than $5,000";
      isValid = false;
    }

    if (isValid) showOptions = !showOptions;
  }
</script>

<style>
  form {
    width: 100%;
    max-width: 330px;
    padding: 15px;
    margin: auto;
  }
</style>

{#if showOptions}
  <LoanOptions
    {loanAmount}
    {creditScore}
    {borrowerCount}
    {state}
    {closingDate}
    on:startOver={() => (showOptions = !showOptions)} />
{:else}
  <div class="calc-container">
    <form on:submit|preventDefault={showRates}>
      <div class="text-center">
        <h1 class="h3 mb-3 font-weight-normal">Calculate loan options</h1>
      </div>

      <div class="form-group">
        <label for="sel1">State</label>
        <select class="form-control" bind:value={state}>
          <option>--</option>
          <option>Alabama - AL</option>
          <option>Alaska - AK</option>
          <option>Arizona - AZ</option>
          <option>Arkansas - AR</option>
          <option>California - CA</option>
          <option>Colorado - CO</option>
          <option>Connecticut - CT</option>
          <option>Delaware - DE</option>
          <option>District of Columbia - DC</option>
          <option>Florida - FL</option>
          <option>Georgia - GA</option>
          <option>Hawaii - HI</option>
          <option>Idaho - ID</option>
          <option>Illinois - IL</option>
          <option>Indiana - IN</option>
          <option>Iowa - IA</option>
          <option>Kansas - KS</option>
          <option>Kentucky - KY</option>
          <option>Louisiana - LA</option>
          <option>Maine - ME</option>
          <option>Maryland - MD</option>
          <option>Massachusetts - MA</option>
          <option>Michigan - MI</option>
          <option>Minnesota - MN</option>
          <option>Mississippi - MS</option>
          <option>Missouri - MO</option>
          <option>Montana - MT</option>
          <option>Nebraska - NE</option>
          <option>Nevada - NV</option>
          <option>New Hampshire - NH</option>
          <option>New Jersey - NJ</option>
          <option>New Mexico - NM</option>
          <option>New York - NY</option>
          <option>North Carolina - NC</option>
          <option>North Dakota - ND</option>
          <option>Ohio - OH</option>
          <option>Oklahoma - OK</option>
          <option>Oregon - OR</option>
          <option>Pennsylvania - PA</option>
          <option>Rhode Island - RI</option>
          <option>South Carolina - SC</option>
          <option>South Dakota - SD</option>
          <option>Tennessee - TN</option>
          <option>Texas - TX</option>
          <option>Utah - UT</option>
          <option>Vermont - VT</option>
          <option>Virginia - VA</option>
          <option>Washington - WA</option>
          <option>West Virginia - WV</option>
          <option>Wisconsin - WI</option>
          <option>Wyoming - WY</option>
        </select>
        <ValidationError message={stateValidationError} />

        <label>Loan Amount</label>
        <input
          type="number"
          class="form-control text-left"
          id="loanAmount"
          aria-describedby="loanAmount"
          placeholder="Loan Amount"
          bind:value={loanAmount}
          on:change={() => (loanAmountValidationError = null)} />
        <ValidationError message={loanAmountValidationError} />

        <label>Credit Score</label>
        <input
          type="number"
          class="form-control"
          id="creditScore"
          placeholder="Credit Score"
          bind:value={creditScore}
          on:change={() => (creditScoreValidationError = null)} />
        <ValidationError message={creditScoreValidationError} />

        <label>Number of borrowers</label>
        <input
          type="number"
          class="form-control"
          id="borrowerCount"
          placeholder="# of borrowers"
          bind:value={borrowerCount}
          on:change={() => (borrowerCountValidationError = null)} />
        <ValidationError message={borrowerCountValidationError} />

        <label>Closing Date (optional)</label>
        <input
          type="date"
          class="form-control"
          id="closingDate"
          bind:value={closingDate} />
      </div>
      <div style="padding-top:1em;">
        <button class="btn btn-lg btn-primary btn-block" type="submit">
          Get Loan Options
        </button>
      </div>
    </form>
  </div>
{/if}
